// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h-Sx","left":"styles_left__1nr_M","desktopActions":"styles_desktopActions__3szic","title":"styles_title__3aHwR"};